import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateCarriers } from '@/modules/Carrier/gql/carrier.gql'
import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchCarrier extends Vue {
  candidatesCarrier: Carrier[] = []

  get candidatesCarrierNameOptions () {
    return this.candidatesCarrier.map(item => {
      return item.name
    })
  }

  get candidatesCarrierOptions () {
    return this.candidatesCarrier.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  async created () {
    await this.getCandidateCarriers()
  }

  async mounted () {
    await this.getCandidateCarriers()
  }

  async getCandidateCarriers (val?: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateCarriers,
        variables: {
          filter: {
            name: val || ''
          },
          paging: null
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesCarrier = this.$R.sortBy(this.$R.compose(this.$R.toLower, this.$R.prop('name')))(result.data.getCarriers.carriers)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
